import {put, take, fork} from 'redux-saga/effects';
import {LOCATION_CHANGE} from 'connected-react-router';
import {getContentItemViewArtwork} from '@pluto/rest';
import {setNotificationError} from '@pluto/notification';
import {compose, getFrom, isEqual, payloadGenerator} from '@pluto/utils';
import {ArtworkItem, ArtworkStatus} from '../../../ContentItemViewArtworkTypes&Const';
import {
    CONTENT_ITEM_VIEW_ARTWORK_DELETE,
    CONTENT_ITEM_VIEW_ARTWORK_RETRY,
    setContentItemViewArtwork,
} from '../../ContentItemViewArtworkActions';

interface Props {
    type: string;
    payload: number;
}

export const predicate = ({artwork = [] as ArtworkItem[]} = {}) => {
    return artwork.some(compose(isEqual(ArtworkStatus.pending), getFrom('status')));
};

export function* setArtworks({payload: id}: Props) {
    try {
        const generator = yield fork(
            payloadGenerator,
            setContentItemViewArtwork,
            predicate,
            getContentItemViewArtwork,
            id
        );

        yield take([
            LOCATION_CHANGE,
            CONTENT_ITEM_VIEW_ARTWORK_RETRY,
            CONTENT_ITEM_VIEW_ARTWORK_DELETE,
        ]);

        generator.cancel();
    } catch (error) {
        yield put(setNotificationError(error.message));
    }
}
